<template>
<svg class="logo" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 16L8.02667 7.97333L16 16H0Z" fill="url(#paint0_linear)"/>
<path d="M0 0H8.02667L0 8.66667V0Z" fill="url(#paint1_linear)"/>
<path d="M8.02667 0L0 8.45333V16L8.02667 7.97333L16 0H8.02667Z" fill="url(#paint2_linear)"/>
<defs>
<linearGradient id="paint0_linear" x1="4.25584" y1="19.7371" x2="11.8151" y2="12.1778" gradientUnits="userSpaceOnUse">
<stop offset="0.09677" stop-color="#0095D5"/>
<stop offset="0.3007" stop-color="#238AD9"/>
<stop offset="0.6211" stop-color="#557BDE"/>
<stop offset="0.8643" stop-color="#7472E2"/>
<stop offset="1" stop-color="#806EE3"/>
</linearGradient>
<linearGradient id="paint1_linear" x1="1.12245" y1="3.21576" x2="5.51291" y2="-1.17467" gradientUnits="userSpaceOnUse">
<stop offset="0.1183" stop-color="#0095D5"/>
<stop offset="0.4178" stop-color="#3C83DC"/>
<stop offset="0.6962" stop-color="#6D74E1"/>
<stop offset="0.8333" stop-color="#806EE3"/>
</linearGradient>
<linearGradient id="paint2_linear" x1="-2.69379" y1="14.7103" x2="12.1951" y2="-0.178507" gradientUnits="userSpaceOnUse">
<stop offset="0.1075" stop-color="#C757BC"/>
<stop offset="0.2138" stop-color="#D0609A"/>
<stop offset="0.4254" stop-color="#E1725C"/>
<stop offset="0.6048" stop-color="#EE7E2F"/>
<stop offset="0.743" stop-color="#F58613"/>
<stop offset="0.8232" stop-color="#F88909"/>
</linearGradient>
</defs>
</svg>


</template>

<script>
export default {
  name: 'kotlin-icon'
}
</script>

<style>
.logo {
  fill: currentColor
}
</style>